import PropTypes from "prop-types";
import { useDrop } from "react-dnd";
import "../../style/DroppableZone.css"

const DroppableZone = ({ index, onDrop }) => {
  const [{isOver, canDrop}, drop] = useDrop(() => ({
    accept: "album",
    drop: (item) => { //Défini l'action à faire
        onDrop(index);
    },
    collect: (monitor) => ({  //Défini des params
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }), []);
  
  return (
    <div
      ref={drop}
      className={`droppableZone_div ${isOver?`isOver`:``}`}
    >
    </div>
  );
};
DroppableZone.propTypes = {
  index: PropTypes.number.isRequired,
};
export default DroppableZone;
